export interface ParsedCoord {
  lat: number
  lng: number
}

// Parse a lat/lng out of free text the user pastes. Supports:
//  - plain "46.4769, 11.7700" (comma, optional spaces)
//  - Google Maps URLs: ".../@46.4769,11.7700,15z"
//  - Google Maps place URLs: "...!3d46.4769!4d11.7700"
//  - query-style links: "?q=46.4769,11.7700", "?query=...", "ll=...", "q=loc:lat,lng"
// Returns null if no valid coordinate pair is found.
export function parseCoordinates(input: string): ParsedCoord | null {
  if (!input) return null
  const s = input.trim()

  // Google Maps "@lat,lng,zoom"
  const at = s.match(/@(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/)
  if (at) return validate(Number(at[1]), Number(at[2]))

  // Google Maps place markers "!3dlat!4dlng"
  const bang = s.match(/!3d(-?\d{1,3}\.\d+)!4d(-?\d{1,3}\.\d+)/)
  if (bang) return validate(Number(bang[1]), Number(bang[2]))

  // Query-style links
  const q = s.match(/[?&](?:q|query|destination|ll)=(?:loc:)?(-?\d{1,3}\.\d+),\s*(-?\d{1,3}\.\d+)/)
  if (q) return validate(Number(q[1]), Number(q[2]))

  // Plain "lat, lng"
  const plain = s.match(/^(-?\d{1,3}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)$/)
  if (plain) return validate(Number(plain[1]), Number(plain[2]))

  return null
}

function validate(lat: number, lng: number): ParsedCoord | null {
  if (
    Number.isFinite(lat) && Number.isFinite(lng) &&
    lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180
  ) {
    return { lat, lng }
  }
  return null
}
